/**
 * Staking transaction hooks
 *
 * These hooks provide a clean interface for executing staking operations
 * with automatic state management and error handling.
 */

export { useStakeTransaction, type UseStakeTransactionReturn } from "./useStakeTransaction";

export { useStartUnstakeTransaction, type UseStartUnstakeTransactionReturn } from "./useStartUnstakeTransaction";

export { useUnstakeTransaction, type UseUnstakeTransactionReturn } from "./useUnstakeTransaction";

export { useStakingStats } from "@solomon-apps/shared";
export { useUserStakingStats } from "./useUserStakingStats";

export { useStakingVaultDerived } from "./useStakingVaultDerived";
export { useCanUnstakeSusdv } from "./useCanUnstakeSusdv";
